import {
  Box,
  Center,
  Fade,
  Flex,
  Grid,
  Image,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import "./StoryList.css";

const imageList = [
  "https://images.pexels.com/photos/6957997/pexels-photo-6957997.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/4992706/pexels-photo-4992706.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/6758017/pexels-photo-6758017.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/5241294/pexels-photo-5241294.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/8279891/pexels-photo-8279891.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.pexels.com/photos/8029007/pexels-photo-8029007.jpeg?auto=compress&cs=tinysrgb&w=600",
];

export const StoryList: React.FC<any> = () => {
  const StoryItem: React.FC<any> = ({ imgSrc }) => {
    return (
      <Fade in={true}>
        <VStack>
          <Box
            width="100px"
            height="100px"
            bg={
              "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)"
            }
            padding="3px"
            borderRadius={"50%"}
          >
            <Box
            border="4px solid white"
              margin="auto"
              width="94px"
              height="94px"
              // className="white-grad"
              // border="4px solid #d6249f"
              borderRadius={"50%"}
              overflow="hidden"
              backgroundImage={imgSrc}
              backgroundSize="cover"
              // bg="radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)"
            ></Box>
          </Box>
          <Box>
            <Text textAlign={"center"} fontSize={"0.8em"}>
              Story Name
            </Text>
          </Box>
        </VStack>
      </Fade>
    );
  };

  return (
    <Box mt="2em">
      <SimpleGrid minChildWidth="90px" spacing="20px" textAlign={"center"}>
        {imageList.map((item) => {
          return <StoryItem imgSrc={item} />;
        })}
        {imageList.map((item) => {
          return <StoryItem imgSrc={item} />;
        })}
      </SimpleGrid>
    </Box>
  );
};
